<template>
  <div class="msc-ag-select-editor">
    <v-select
      ref="select"
      v-model="selected"
      :items="options"
      item-text="name"
      item-value="name"
      :multiple="multiple"
      :chips="multiple"
      :small-chips="multiple"
      :deletable-chips="multiple"
      dense
      hide-details
      clearable
      placeholder="Select…"
      :menu-props="menuProps"
      @change="onSelectChange"
      @blur="onEditorBlur"
      @keydown.stop
    />
  </div>
</template>

<script>
export default {
  name: 'MscReportSelectCellEditor',
  data() {
    return {
      selected: null,
    };
  },
  computed: {
    parent() {
      return this.params && this.params.context && this.params.context.componentParent;
    },
    editorParams() {
      const colParams = this.params && this.params.colDef && this.params.colDef.cellEditorParams;
      return colParams || {};
    },
    optionsKey() {
      return this.editorParams.optionsKey || (this.params && this.params.optionsKey);
    },
    multiple() {
      return Boolean(this.editorParams.multiple);
    },
    options() {
      if (!this.parent || !this.optionsKey) return [];
      return this.parent.getMscSelectOptions(this.optionsKey) || [];
    },
    menuProps() {
      return {
        maxHeight: 280,
        offsetY: true,
        attach: true,
        closeOnClick: !this.multiple,
        closeOnContentClick: false,
      };
    },
  },
  mounted() {
    this.selected = this.normalizeInitialValue(this.params && this.params.value);
    this.$nextTick(() => this.focusSelect());
  },
  methods: {
    normalizeInitialValue(val) {
      if (val == null || val === '' || val === '-') {
        return this.multiple ? [] : null;
      }
      const lines = String(val).split('\n').map((s) => s.trim()).filter(Boolean);
      if (this.multiple) return lines;
      return lines[0] || null;
    },
    focusSelect() {
      const input = this.$refs.select && this.$refs.select.$el
        && this.$refs.select.$el.querySelector('input');
      if (input) input.focus();
    },
    afterGuiAttached() {
      this.$nextTick(() => this.focusSelect());
    },
    commitEdit() {
      this.$nextTick(() => {
        if (this.params && typeof this.params.stopEditing === 'function') {
          this.params.stopEditing();
        }
      });
    },
    onSelectChange() {
      if (!this.multiple) {
        this.commitEdit();
      }
    },
    onEditorBlur() {
      if (this.multiple) {
        this.commitEdit();
      }
    },
    getValue() {
      if (this.multiple) {
        if (!Array.isArray(this.selected) || !this.selected.length) return '';
        return this.selected.join('\n');
      }
      return this.selected || '';
    },
  },
};
</script>

<style scoped>
.msc-ag-select-editor {
  height: 100%;
  min-width: 180px;
  padding: 2px 4px;
  width: 100%;
}

.msc-ag-select-editor >>> .v-input {
  margin-top: 0;
  padding-top: 0;
}
</style>
